var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.993,
    viewBox: "0 0 30 29.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M15,9.544a7.69,7.69,0,1,0,7.69,7.69A7.678,7.678,0,0,0,15,9.544Zm0,12.689a5,5,0,1,1,5-5,5.009,5.009,0,0,1-5,5Zm9.8-13A1.794,1.794,0,1,1,23,7.436,1.789,1.789,0,0,1,24.8,9.23Zm5.093,1.82a8.876,8.876,0,0,0-2.423-6.284,8.935,8.935,0,0,0-6.284-2.423c-2.476-.141-9.9-.141-12.375,0A8.922,8.922,0,0,0,2.523,4.759,8.9,8.9,0,0,0,.1,11.044c-.141,2.476-.141,9.9,0,12.375A8.876,8.876,0,0,0,2.523,29.7a8.946,8.946,0,0,0,6.284,2.423c2.476.141,9.9.141,12.375,0A8.876,8.876,0,0,0,27.467,29.7a8.935,8.935,0,0,0,2.423-6.284c.141-2.476.141-9.892,0-12.368Zm-3.2,15.025a5.062,5.062,0,0,1-2.851,2.851c-1.974.783-6.659.6-8.841.6s-6.873.174-8.841-.6a5.062,5.062,0,0,1-2.851-2.851c-.783-1.974-.6-6.659-.6-8.841s-.174-6.873.6-8.841A5.062,5.062,0,0,1,6.157,5.542c1.974-.783,6.659-.6,8.841-.6s6.873-.174,8.841.6A5.062,5.062,0,0,1,26.69,8.393c.783,1.974.6,6.659.6,8.841S27.473,24.108,26.69,26.075Z",
    transform: "translate(0.005 -2.238)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.17a0021e62ec4098e4bfc0be1f116ff7.svg";
export { ForwardRef as ReactComponent };